/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorJwVideoTeaser from 'sites/allas/components/labrador/JwVideo/Teaser';

export const DynamicLabradorJwVideoTeaser: typeof LabradorJwVideoTeaser = (props) => {
    return <ErrorBoundary><LabradorJwVideoTeaser {...props} /></ErrorBoundary>;
}
export type DynamicLabradorJwVideoTeaserProps = PropsFromComponent<typeof LabradorJwVideoTeaser>;
